import {get, post} from "@/services/api";

const state = {
    academics: [],
    errorMessage: '',
    fetchedUser: null
};

const getters = {
    getAcademics: state => state.academics,
    fetchedUser: state => state.fetchedUser,
    errorMessage: state => state.errorMessage
}

const actions = {
    async fetchAllAcademics({commit}) {
        const response = await get('gamification/academic/');
        commit('setAcademics', response.data.items);
    },
    // eslint-disable-next-line
    async createGamificationProfiles({ commit },request){
        try {
            const response =  await post('gamification/academic/', request)
            return response.data.items
        } catch (e) {
            console.log('error ', e)
        }
    },
    async fetchByLoginOrId({ commit },{login, uisId}){
        try{
            const params = []
            if (login) params.push(`xlogin=${login}`)
            if (uisId) params.push(`uisId=${uisId}`)
            const uri = `api/users/search?${params.join('&')}`
            //const uri = `api/users/search?${login && `login=${login}`}${login && uisId && '&'}${uisId && `uisId=${uisId}`}`
            const response = await get(uri)
            if(response.data.content){
                commit('setFetchedUser', response.data.content)
                commit('setErrorMessage', '')
            }
        } catch (e) {
            console.log('error ', e)
            if(e.statusCode === 404){
                commit('setErrorMessage', 'Uživatel nenalezen.')
            } else {
                commit('setErrorMessage', 'Chyba. Zkuste to prosím znovu.')
            }
        }
    },
    clear({ commit }){
        commit('setErrorMessage', '')
        commit('setFetchedUser', null)
    }
}

const mutations = {
    setAcademics: (state, academics) => (state.academics = academics),
    setFetchedUser: (state, user) => (state.fetchedUser = user),
    setErrorMessage: (state, message) => (state.errorMessage = message)
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}